import React from 'react';
import moment from 'moment';

import './AutoFilledRequests.less';

/**
 *
 * @param {{
 *  requests?: import('../../../../store/reducers/dashboardReducer').TEvaluationRequest[];
 *  highlightWords?: string[];
 * }} props
 * @returns
 */
const AutoFilledRequests = props => {
  const { requests = [], highlightWords = [] } = props;

  /**
   *
   * @param {?string=} str
   * @param {?string[]=} words
   * @returns
   */
  const getHighlightedStr = (str, words) => {
    let htxt = str ?? '';
    for (const word of words ?? []) {
      htxt = htxt.replaceAll(new RegExp(word.replace(/<|>/g, ''), 'gi'), `<u class='found-word bg-yellow'>$&</u>`);
    }
    return htxt;
  };

  const organizationToProgramsPairs = (requests ?? [])
    .map(request =>
      Object.entries(request.programNames).map(([key, value]) => ({
        org: getHighlightedStr(key, highlightWords),
        program: getHighlightedStr(value, highlightWords),
        responseDate: request.responseDate,
      }))
    )
    .flat()
    .sort((a, b) => a.org.localeCompare(b.org));

  /**
   *
   * @param {{org:string; program:string; responseDate:any}} orgProgPair
   * @param {number} index
   * @returns
   */
  const createRequestRow = (orgProgPair, index) => {
    return (
      <div className="auto-filled-requests__row">
        <div className="auto-filled-requests__programs">
          <span className="organization-name" dangerouslySetInnerHTML={{ __html: orgProgPair.org }}></span>
          {' - '}
          <span className="program-names" dangerouslySetInnerHTML={{ __html: orgProgPair.program }}></span>
        </div>
        <div className="auto-filled-requests__dates">{moment(orgProgPair.responseDate).format('MMM DD, YYYY')}</div>
      </div>
    );
  };

  return organizationToProgramsPairs.length > 0 ? (
    <div className="auto-filled-requests__container">
      <div className="auto-filled-requests__row">
        <b>
          <i className="far fa-copy auto-filled-requests__icon" />
          Reused For:
          <span className="badge-count">{organizationToProgramsPairs.length}</span>
        </b>
        <b>Submitted On:</b>
      </div>
      {organizationToProgramsPairs.map(createRequestRow)}
    </div>
  ) : null;
};

export default AutoFilledRequests;
